export default __webpack_public_path__ + "static/media/home.1e6a3b00.jpg";